import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import {
  CellError,
  IFailedPayload,
  IUploadRequest,
  IUploadResponse,
} from '../../types/BulkUploadAgent.types';

export interface BulkUploadAgentState {
  data: IUploadResponse | null;
  loading: boolean;
  error: IFailedPayload | null;
  totalRows: number;
  errorCount: number;
  errors: CellError[];
  isSuccess: boolean;
}

export const bulkUploadAgentInitialState: BulkUploadAgentState = {
  data: null,
  loading: false,
  error: null,
  totalRows: 0,
  errorCount: 0,
  errors: [],
  isSuccess: false,
};

const bulkUploadAgentSlice = createSlice({
  name: 'bulkUploadAgent',
  initialState: bulkUploadAgentInitialState,
  reducers: {
    bulkUploadAgentFile: (state, _action: PayloadAction<IUploadRequest>) => {
      state.loading = true;
      state.error = null;
    },
    bulkUploadAgentFileSuccess: (
      state,
      action: PayloadAction<IUploadResponse>
    ) => {
      state.data = action.payload;
      state.loading = false;
      state.totalRows = action.payload.totalRows;
      state.errorCount = action.payload.errorCount;
      state.errors = action.payload.errors;
      state.isSuccess = action.payload.errorCount === 0;
    },
    bulkUploadAgentFileFailure: (
      state,
      action: PayloadAction<IFailedPayload>
    ) => {
      state.error = action.payload;
      state.loading = false;
      // If error includes response data (partial success with errors)
      if (action.payload.response) {
        state.data = action.payload.response;
        state.totalRows = action.payload.response.totalRows;
        state.errorCount = action.payload.response.errorCount;
        state.errors = action.payload.response.errors;
        state.isSuccess = false;
      }
    },
    resetUploadState: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
      state.totalRows = 0;
      state.errorCount = 0;
      state.errors = [];
      state.isSuccess = false;
    },
  },
});

export const {
  bulkUploadAgentFile,
  bulkUploadAgentFileSuccess,
  bulkUploadAgentFileFailure,
  resetUploadState,
} = bulkUploadAgentSlice.actions;

export default bulkUploadAgentSlice.reducer;
